const basePaths = {
  auth: "/auth",
  settings: "/setting",
  dashboard: "/dashboard",
  translation: "/translation",
  mobile: "/mobile",
  emailTemplate: "/email-template",
  cms: "/cms",
  smsTemplate: "/sms-template",
  user: "/user",
  serviceCategory: "/service-category",
  subscriptionPlan: "/subscription-plan",
  dummyUser: "/dummy-user",
  freelancerUser: "/freelancer-user",
  review: "/review",
  notification: "/notification",
  subscribedUser: "/subscribed-user",
  referralRecord: "/referral-record",
  communityLeaderboard: "/community-leaderboard",
};

module.exports = {
  auth: {
    login: `${basePaths.auth}/login`,
    forgotPassword: `${basePaths.auth}/forgot-password`,
    resendForgotOtp: `${basePaths.auth}/resend-forgot-otp`,
    verifyOtp: `${basePaths.auth}/verify-otp`,
    resetPassword: `${basePaths.auth}/reset-password`,
    changePassword: `${basePaths.auth}/change-password`,
    updateProfile: `${basePaths.auth}/profile`,
    getProfile: `${basePaths.auth}/profile/get`,
    logout: `${basePaths.auth}/logout`,
    sendEmailVerificationOtp: `${basePaths.auth}/send-email-verification-otp`,
    verifyEmailOtp: `${basePaths.auth}/verify-email-otp`,
  },
  settings: {
    updateConfiguration: `${basePaths.settings}/update-general`,
    getConfiguration: `${basePaths.settings}/list`,
    getCountry: `${basePaths.settings}/get-country`,
  },
  dashboard: {
    getCounts: `${basePaths.dashboard}/get-counts`,
    getUserChart: `${basePaths.dashboard}/get-user-chart`,
  },
  translation: {
    sync: `${basePaths.translation}/sync`,
    list: `${basePaths.translation}/list`,
    add: `${basePaths.translation}/add`,
    get: `${basePaths.translation}/get`,
    getLanguages: `${basePaths.translation}/get-languages`,
    update: `${basePaths.translation}/update`,
    delete: `${basePaths.translation}/delete`,
    export: `${basePaths.translation}/export`,
    import: `${basePaths.translation}/import`,
  },
  cms: {
    list: `${basePaths.cms}/list`,
    add: `${basePaths.cms}/add`,
    updateStatus: `${basePaths.cms}/update-status`,
    uploadImage: `${basePaths.cms}/upload-image`,
    delete: `${basePaths.cms}/delete`,
    // Public (login-free) page content; the slug is appended: /cms/public/:slug
    getPublicPage: `${basePaths.cms}/public`,
    get: `${basePaths.cms}/get`,
    update: `${basePaths.cms}/update`,
  },
  emailTemplate: {
    list: `${basePaths.emailTemplate}/list`,
    add: `${basePaths.emailTemplate}/add`,
    get: `${basePaths.emailTemplate}/get`,
    update: `${basePaths.emailTemplate}/update`,
    delete: `${basePaths.emailTemplate}/delete`,
  },
  smsTemplate: {
    list: `${basePaths.smsTemplate}/list`,
    add: `${basePaths.smsTemplate}/add`,
    get: `${basePaths.smsTemplate}/get`,
    update: `${basePaths.smsTemplate}/update`,
    delete: `${basePaths.smsTemplate}/delete`,
  },
  user: {
    list: `${basePaths.user}/list`,
    get: `${basePaths.user}/get`,
    getAdminUser: `${basePaths.user}/get`,
    updateStatus: `${basePaths.user}/update`,
    delete: `${basePaths.user}/delete`,
    grantPremiumReward: `${basePaths.user}/grant-premium-reward`,
  },
  serviceCategory: {
    list: `${basePaths.serviceCategory}/list`,
    add: `${basePaths.serviceCategory}/add`,
    get: `${basePaths.serviceCategory}/get`,
    update: `${basePaths.serviceCategory}/update`,
    updateStatus: `${basePaths.serviceCategory}/update-status`,
    delete: `${basePaths.serviceCategory}/delete`,
  },
  subscriptionPlan: {
    list: `${basePaths.subscriptionPlan}/list`,
    add: `${basePaths.subscriptionPlan}/add`,
    get: `${basePaths.subscriptionPlan}/get`,
    update: `${basePaths.subscriptionPlan}/update`,
    updateStatus: `${basePaths.subscriptionPlan}/update-status`,
    delete: `${basePaths.subscriptionPlan}/delete`,
  },
  dummyUser: {
    list: `${basePaths.dummyUser}/list`,
    add: `${basePaths.dummyUser}/add`,
    get: `${basePaths.dummyUser}/get`,
    update: `${basePaths.dummyUser}/update`,
    updateStatus: `${basePaths.dummyUser}/update-status`,
    delete: `${basePaths.dummyUser}/delete`,
  },
  freelancerUser: {
    list: `${basePaths.freelancerUser}/list`,
    get: `${basePaths.freelancerUser}/get`,
    approveApplication: `${basePaths.freelancerUser}/approve-application`,
    rejectApplication: `${basePaths.freelancerUser}/reject-application`,
    approveDocuments: `${basePaths.freelancerUser}/approve-documents`,
    rejectDocuments: `${basePaths.freelancerUser}/reject-documents`,
    approveService: `${basePaths.freelancerUser}/approve-service`,
    rejectService: `${basePaths.freelancerUser}/reject-service`,
    grantPremiumReward: `${basePaths.freelancerUser}/grant-premium-reward`,
  },
  review: {
    list: `${basePaths.review}/list`,
    get: `${basePaths.review}/get`,
    delete: `${basePaths.review}/delete`,
  },
  notification: {
    list: `${basePaths.notification}/list`,
    unreadCount: `${basePaths.notification}/unread-count`,
    readOne: `${basePaths.notification}/read-one`,
    readAll: `${basePaths.notification}/read-all`,
    deleteAll: `${basePaths.notification}/delete-all`,
  },
  subscribedUser: {
    list: `${basePaths.subscribedUser}/list`,
    get: `${basePaths.subscribedUser}/get`,
    transactions: `${basePaths.subscribedUser}/transactions`,
    documents: `${basePaths.subscribedUser}/documents`,
    approveVerification: `${basePaths.subscribedUser}/approve-verification`,
    rejectVerification: `${basePaths.subscribedUser}/reject-verification`,
  },
  referralRecord: {
    list: `${basePaths.referralRecord}/list`,
    countries: `${basePaths.referralRecord}/countries`,
    get: `${basePaths.referralRecord}/get`,
    rewardHistory: `${basePaths.referralRecord}/reward-history`,
    markFraudulent: `${basePaths.referralRecord}/mark-fraudulent`,
  },
  communityLeaderboard: {
    list: `${basePaths.communityLeaderboard}/list`,
  },
};
